import { render, staticRenderFns } from "./TelcoResult.vue?vue&type=template&id=197c350a&"
import script from "./TelcoResult.vue?vue&type=script&lang=ts&"
export * from "./TelcoResult.vue?vue&type=script&lang=ts&"
import style0 from "./TelcoResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports